<template lang="pug">
  v-app
    v-app-bar(app='', color="#8b2639", dark='' clipped-left='' v-if="header").mb-3
        img(src='https://bgpu.ru/galleries/logo.png' onclick="location.href = 'https://bgpu.ru/index.jsp'" align='left', tag='span', style='cursor: pointer').hidden-sm-and-down
        img(src='https://bgpu.ru/galleries/logo3.png' height='78px' onclick="location.href = 'https://bgpu.ru/index.jsp'" align='left', tag='span', style='cursor: pointer').hidden-md-and-up
        v-spacer
        v-toolbar-title.hidden-sm-and-down Благовещенский государственный педагогический университет
        v-toolbar-title.hidden-md-and-up БГПУ
    v-content
      router-view
</template>

<script>

export default {
  name: 'App',

  components: {

  },
  mounted () {
    try {
      this.header = window !== window.top || document !== top.document || self.location !== top.location
    } catch (e) {
      this.header = true
    }
    if (this.header) {
      this.header = false
    } else {
      this.header = true
    }
    // if (window !== window.top) {
    //   this.header = false
    // } else {
    //   this.header = true
    // }
  },
  data: () => ({
    header: false
  })
}
</script>
